import { ApolloLink, Observable } from '@apollo/client/core';
import { createClient } from 'graphql-ws';
import { print } from 'graphql';
import { forceLogout } from '@/utils/forceLogout';

const isSubscriptionDeniedError = error => {
  return error?.message && error.message.includes('Subscription denied');
};

export default class WebSocketCustomLink extends ApolloLink {
  constructor(options) {
    super();
    this.client = createClient(options);
  }
  request(operation) {
    return new Observable(sink => {
      return this.client.subscribe(
        { ...operation, query: print(operation.query) },
        {
          next: data => {
            if (data?.errors && Array.isArray(data.errors)) {
              const hasSubscriptionDeniedError = data.errors.some(
                isSubscriptionDeniedError
              );

              if (hasSubscriptionDeniedError) {
                console.warn(
                  'Subscription denied error detected, logging out user'
                );
                forceLogout();
                return;
              }
            }

            sink.next(data);
          },
          complete: sink.complete.bind(sink),
          error: err => {
            if (err instanceof Error) {
              return sink.error(err);
            }

            if (err instanceof CloseEvent) {
              return sink.error(
                // reason will be available on clean closes
                new Error(
                  `Socket closed with event ${err.code} ${err.reason || ''}`
                )
              );
            }

            return sink.error(
              new Error(err.map(({ message }) => message).join(', '))
            );
          }
        }
      );
    });
  }
}
